<template>
    <fragment>
        <c-hero-full class="illustration-section-01" />
        <c-features-tiles class="illustration-section-02" />
        <c-features-split invert-mobile top-divider image-fill class="illustration-section-03" />
        <c-generic-section id="faqs" top-divider>
            <div style="padding-left: 2rem; padding-right: 2rem;" class="container-sm">
                <c-accordion>
                  <div class="container-sm">
                    <c-accordion-item title="What's different about Pixtel?">
                        Pixtel is built specifically for screenshot power users like developers, QA testers, and designers, who use screenshots to communicate key information on their screen on a daily basis. Pixtel is also built with an exclusive focus on Windows operating systems to run as fast and as light as possible on them, so leaving it open doesn't hog your battery.
                    </c-accordion-item>
                    <c-accordion-item title="What operating systems does Pixtel run on?">
                        Pixtel is optimized for and runs exclusively on Windows computers. You can download and run it on Windows 7-11, though a few features in Windows 11 are being actively tested.
                    </c-accordion-item>
                    <c-accordion-item title="Does Pixtel store any of my images on the cloud?">
                        No, Pixtel does not store any of your image data or metadata anywhere but your own device, unless you explicitly send data elsewhere.
                    </c-accordion-item>
                    <c-accordion-item title="How do I get Pixtel for my team?">
                        You can purchase business plans directly from the buttons in the plans section below, or if you’re looking to use Prefix on a large team, feel free to reach out to us directly at <a href="mailto:sales@pixtel.us">sales@pixtel.us</a>. We’re happy to give you a walkthrough of the product, or work with you to see if there’re features specific to your team’s workflows we can make easier with Pixtel.
                    </c-accordion-item>
                    <c-accordion-item title="Discounts for educational instutions and non-profits?">
                        If you work at an educational instution or non-profit, our licensing allows you to buy our personal license for business use (50% off).
                    </c-accordion-item>
                  </div>
                </c-accordion>
            </div>
        </c-generic-section>
        <c-pricing top-divider pricing-switcher />
        <c-testimonial has-bg-color invert-color />
        <c-cta has-bg-color invert-color class="illustration-section-04" />
    </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutDefault.vue'
// import sections
import CHeroFull from '@/components/sections/HeroFull.vue'
import CFeaturesTiles from '@/components/sections/FeaturesTiles.vue'
import CFeaturesSplit from '@/components/sections/FeaturesSplit.vue'
import CPricing from '@/components/sections/Pricing.vue'
import CTestimonial from '@/components/sections/TestimonialCarousel.vue'
import CCta from '@/components/sections/Cta.vue'
import CAccordion from '@/components/elements/Accordion.vue'
import CAccordionItem from '@/components/elements/AccordionItem.vue'
import CGenericSection from '@/components/sections/GenericSection.vue'

export default {
  name: 'Home',
  components: {
    CGenericSection,
    CHeroFull,
    CFeaturesTiles,
    CFeaturesSplit,
    CPricing,
    CTestimonial,
    CCta,
    CAccordion,
    CAccordionItem
  },
  created() {
    this.$emit('update:layout', CLayout)
  }
}
</script>
